

import styled from "styled-components"
import { useSelector, useDispatch } from "react-redux";
import { getNakliyeHesaplama, setIsDurationStrict, updateJobDuration } from "../../../../features/nakliyeHesaplama/nakliyeHesaplamaSlice";

const Container = styled.div`
    width: ${({inputWidth}) => inputWidth};
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;
    color: ${({theme}) => theme.mainTextColor};

    .input-wrapper{

        display: flex;
        height: 40px;

        .box{

            width: 35px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.8rem;
            color: ${({theme}) => theme.secondaryTextColor};
            cursor: pointer;
            border: 1px solid ${({theme}) => theme.mainBorderColor};

            &:hover{
                color: ${({theme}) => theme.mainTextColor};
            }
        }

        .box-minus{
            border-right: none;
            border-bottom-left-radius: 5px;
            border-top-left-radius: 5px;
        }

        .box-plus{
            border-left: none;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }

    input{
        width: calc(100% - 70px);
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 50px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }
`

const InputJobDuration = ({isRequired, name, labelText, inputWidth}) => {

    const dispatch = useDispatch()


    const {
        truckType,
        route,
        kmData,
        tonajData,
        jobDuration,
        selectedRouteItem
      } = useSelector(state => state.nakliyeHesaplama)

    const {
        yakitData
    } = useSelector(state => state.calc)

    const handleChange = (e) => {
        const data = e.target.value.replace(/[^0-9]/g, '')
        dispatch(updateJobDuration(data))
        dispatch(setIsDurationStrict(true))
    }

    const handleDurationChangeBtn = (type) => {

        if(type === "minus"){

            if(jobDuration >= 1){
                dispatch(updateJobDuration(parseFloat(jobDuration) - 0.5));
                dispatch(setIsDurationStrict(true))
                getNakliyeHesaplamaRequest(parseFloat(jobDuration) - 0.5)

                
            }
        }

        else{
            if(jobDuration < 10){
                dispatch(updateJobDuration(parseFloat(jobDuration) + 0.5))
                dispatch(setIsDurationStrict(true))
                getNakliyeHesaplamaRequest(parseFloat(jobDuration) + 0.5)
            }
        }
    }


      const getNakliyeHesaplamaRequest = (duration) => {
    
        const filledRoutePoints = route.filter(item => {
          return item.lat && item.lng
        }) 
    
        const lastRoutePoint = filledRoutePoints.findLast(item => {
          return item.lat && item.lng
        }) 
    
        if(
          truckType?.id &&
          route[0]?.cityId &&
          yakitData &&
          kmData &&
          filledRoutePoints.length > 1 &&
          tonajData.value &&
          lastRoutePoint?.lat &&
          lastRoutePoint?.lng
        ){
    
          const body = {
            aracTuru: parseInt(truckType?.id),
            nerden: parseInt(route[0]?.cityId),
            nereye: parseInt(route[route.length - 1]?.cityId),
            km: parseInt(selectedRouteItem?.distanceMeters / 1000),
            tonaj: tonajData.value,
            isKacGunSürecek: duration,
            //!
            guncelYakitFiyati: yakitData,
            districtMernisCode: lastRoutePoint?.mernis,
            nereyeLat: parseFloat(lastRoutePoint?.lat),  
            nereyeLng: parseFloat(lastRoutePoint?.lng),
            isWebPanel: true,
            isDurationStrict: true,
            intermediatesLength: filledRoutePoints.filter((item,i) => {
              return i !== 0 && i+1 !== filledRoutePoints.length && item.isStopOver
            }).length
          }
    
          dispatch(getNakliyeHesaplama(body))
        }
      }
    
    

  return (
    <Container value={jobDuration} radius={"5px"} inputWidth={inputWidth}>
        <div className="input-wrapper">
            <button className="box box-minus" onClick={() => handleDurationChangeBtn("minus")}>-</button>
            <input type="text" onChange={handleChange} value={jobDuration} name={name} />
            <button className="box box-plus" onClick={() => handleDurationChangeBtn("major")}>+</button>
            <label htmlFor={"text"}>{labelText}{isRequired && "*"}</label>
        </div>
    </Container>
  )
}

export default InputJobDuration